module.exports = __webpack_public_path__ + "img/map.f075edf3.png";